import React from "react";
import {connect} from "react-redux";
import parse from "html-react-parser";
import {searchByParams, updateInputsFieldSearch} from "../../../../store/search/actionCreators/search_Inputs";
import {combineMainTableAttributesSearch} from "../../../../store/search/actionCreators/search_table";
import {changeSearchViewMode} from "../../../../store/search/actionCreators/search_RootStateActionCreator";
import {RootComponentsStateViewModeTypes} from "../../../../tools/StaticTypes";
import {history} from "../../../../index";
import {createUniqueIdString} from "../../../../tools/CreateUniqueId";
import sanitizeHtml from "sanitize-html";
import {DataTypesEnum} from "../../../../tools/API_NEW/ServerTypes";
import {__} from "../../../../tools/HelpFunctions";
import {setVersionIdForLocate} from "../../../../store/masterApp/actionCreator/masterAppActionCreator";
import {setModalData} from "../../../../store/globalState/actionCreators/globalState_AppActionCreator";
import DocRef from "../../docRefsComponents/DocRef";
import DocVersionRef from "../../docRefsComponents/DocVersionRef";
import MultipleDocRef from "../../docRefsComponents/MultipleDocRef";
import MultipleDocVersionRef from "../../docRefsComponents/MultipleDocVersionRef";
import JsonObjectFragment from "../../../root/JsonObjectFragment";

const getIdAttributeTypeByItem = (item) => {
    return item.IdAttributeType || item.AttributeName.IdAttributeType
}

class AttributesSectionPackagesMini extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen : false,
        };

        this.toggle = this.toggle.bind(this);
        this.search = this.search.bind(this);

        this.renderJsonObjectFragment = this.renderJsonObjectFragment.bind(this);
    }

    // открытье\закрытие раздела
    toggle() {
        this.setState({
            isOpen : !this.state.isOpen
        });
    }

    search(value) {
        //TODO SS временно
        if (Array.isArray(value)){
            value = value.map(el=>`"${el.split('"').join('').split("'").join('')}"`).join(',')
        } else if (typeof value !== 'string') {
            return;
        } else {
            value = `"${value.split('"').join('').split("'").join('')}"`
        }

        this.props.updateInputsFieldSearch({
            AttributesText : value,
            TypeIds: [],
            Next : {
                action : () => {
                    this.props.searchByParams({
                        Next:{
                            action : () => {
                                this.props.combineMainTableAttributesSearch({
                                    Next : {
                                        action : () => {
                                            this.props.changeSearchViewMode({
                                                ViewMode : RootComponentsStateViewModeTypes.SearchApp.MainTableOnly
                                            });
                                            history.replace("/search");
                                        },
                                        params : {}
                                    }
                                })
                            },
                            params : {}
                        }
                    })
                },
                params : {}
            }
        });
    }

    renderJsonObjectFragment = (item, rowId, IsMultipleAllowed) => {
        let lInputValue = item.Value ?? item.AttributeValue
        if (rowId) {
            if (item.Value && item.Value.length > 0 && (rowId - 1) >= 0 && (rowId - 1) < item.Value.length) {
                lInputValue = item.Value[rowId - 1];
            } else {
                lInputValue = null;
            }
        }
        return <JsonObjectFragment lInputValue={lInputValue}
                                   lAllInputValue={item.Value}
                                   isRedactorMode={false}
                                   rowId={rowId}
                                   item={item}
                                   IsMultipleAllowed
                                   // inputHandler={(value, item) => this.editHandler(IsMultipleAllowed ? {value} : value, item, IsMultipleAllowed)}
        />
    }

    render() {
        let activeDocument;
        if(this.props.tableRole === "main") {
            activeDocument = this.props.activeDocument;
        } else if (this.props.tableRole === "additional") {
            activeDocument = this.props.activeDocumentAdditional;
        } else if (this.props.tableRole === "download") {
            activeDocument = this.props.activeDocumentDownload;
        } else if (this.props.tableRole === "documentsRight") {
            activeDocument = this.props.activeDocumentRight;
        }

        if(!activeDocument) return null;
        let isReady = activeDocument.additionalSections?.isReady;
        let sectionData = activeDocument.additionalSections?.attributesSection?.attributes?.Records;

        let cardTitleClass = "card-title";
        let cardCollapseClass = "collapse show beautiful-scroll-10 ";
        if(!this.state.isOpen) {
            cardTitleClass = "card-title collapsed";
            cardCollapseClass = "collapse";
        }

        /* TODO КН 10.04.24 На текущий момент если this.props.tableRole === "documentsRight" то sectionData уже имеет обьединенные атрибуты,
            т.к. берутся данные из tr таблицы, а для tr таблицы обьединяем их сразу. Можно было бы конечно поставить здесь условие tableRole !== "documentsRight",
            но там данные похоже могут когда то запроситься все таки из запроса, а не из таблицы взяться, поэтому пока так
         */
        sectionData = __.convertAttributesArrayToUnique(sectionData, 'AttributeValue')

        return (
            <div className="card">
                <div className="card-header" onClick={this.toggle}>
                    <div className={cardTitleClass}>
                        Атрибуты документа
                    </div>
                </div>
                <div className={cardCollapseClass}>
                    <div className="card-body p-0 accordion accordion-solid accordion-toggle-plus">


                        <table className="table table-bordered table-striped m-0">
                            <thead>
                            <tr>
                                <th className="col-lg-4">Атрибут</th>
                                <th className="col-lg-7">Значение</th>
                                <th className="col-lg-1">Найти</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                isReady &&
                                sectionData?.map((item, index) => {
                                    const IsMultipleAllowed = item.IsMultipleAllowed
                                    const valueForSanitize = (item.AttributeValue === "null") ? null : item.AttributeValue;
                                    let secondTdContent= parse(sanitizeHtml(valueForSanitize?.toString()));
                                    const attributeType = getIdAttributeTypeByItem(item)
                                    if (attributeType === DataTypesEnum.JsonObject){
                                        const correctValue = !IsMultipleAllowed ? item.AttributeValue : __.getCorrectValueForMultiply(item.AttributeValue)
                                        secondTdContent = (IsMultipleAllowed && correctValue) ?
                                            <div className="d-flex flex-column beautiful-scroll-10"
                                                 style={{
                                                     maxHeight: '5rem',
                                                     paddingRight: correctValue.length > 2 ? '0.75rem' : 0
                                                 }}
                                            >
                                                {correctValue.map((lValue, lIndex) => {
                                                        return (
                                                            <div className={`${lIndex !== correctValue.length - 1 ? 'mb-3' : ''}`}>
                                                                {this.renderJsonObjectFragment({
                                                                    ...item,
                                                                    Value: lValue
                                                                }, null, IsMultipleAllowed)}
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                            :  this.renderJsonObjectFragment({...item, Value: item.AttributeValue}, null, IsMultipleAllowed)
                                    }
                                    else if (attributeType === DataTypesEnum.DocRef) {
                                        secondTdContent = IsMultipleAllowed ?
                                            <MultipleDocRef
                                                item={item}
                                                valueFieldName={'AttributeValue'}
                                                isRedactorMode={false}
                                            />
                                            : <DocRef
                                                docIdValue={item.AttributeValue}
                                                shortDescription={item.ShortDescription}
                                                isRedactorMode={false}
                                            />
                                    } else if (attributeType === DataTypesEnum.DocVersionRef) {
                                        secondTdContent = IsMultipleAllowed ?
                                            <MultipleDocVersionRef
                                                item={item}
                                                valueFieldName={'AttributeValue'}
                                                isRedactorMode={false}
                                            />
                                            : <DocVersionRef
                                                versionIdValue={item.AttributeValue}
                                                shortDescription={item.ShortDescription}
                                                isRedactorMode={false}
                                            />
                                    }
                                    return (
                                        <tr key={createUniqueIdString(6)}>
                                            <td>{item.AttributeName.Name}</td>
                                            <td>{secondTdContent}</td>
                                            <td>
                                                {
                                                    (
                                                        item.AttributeValue !== "null"
                                                        && item.AttributeValue !== null
                                                        && item.AttributeValue !== ''
                                                        && attributeType !== DataTypesEnum.JsonObject
                                                        && attributeType !== DataTypesEnum.DocRef
                                                        && attributeType !== DataTypesEnum.DocVersionRef
                                                    ) &&
                                                    <span className="btn btn-icon btn-outline-success btn-circle btn-xs"
                                                          onClick={()=>{this.search(item.AttributeValue)}}>
                                                    <i className="svg-icon icon-Search"/>
                                                    </span>
                                                }
                                            </td>
                                        </tr>
                                    );
                                })
                            }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

const  mapStateToProps = state => {
    return {
        activeDocument : state.packages.tree.activeDocument,
        activeDocumentAdditional : state.packages.treeAdditional.activeDocument,
        activeDocumentDownload : state.packages.treeDownload.activeDocument,
        activeDocumentRight : state.packages.mainTable.activeDocument,
    }
}

const  mapDispatchToProps = {
    changeSearchViewMode,
    combineMainTableAttributesSearch,
    searchByParams,
    updateInputsFieldSearch,
    setVersionIdForLocate,
    setModalData,
}

export default connect(mapStateToProps, mapDispatchToProps)(AttributesSectionPackagesMini);
